import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { selectFeatureFlag } from "redux/modules/lenndFlags/selectors";
import { HAS_ADMIN_ACCESS } from "utils/feature-flags";
import { isAdminUser } from "utils/admin-utils";

const ToggleFeature = ({
  isFeatureEnabled,
  children,
  untoggledComponent: UntoggledComponent,
  toggledComponent: ToggledComponent
}) => {
  if (ToggledComponent && UntoggledComponent) {
    return isFeatureEnabled ? <ToggledComponent /> : <UntoggledComponent />;
  }

  if (!isFeatureEnabled) {
    return null;
  }

  return children;
};

ToggleFeature.propTypes = {
  flag: PropTypes.string.isRequired,
  children: PropTypes.node,
  isFeatureEnabled: PropTypes.bool.isRequired,
  untoggledComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  toggledComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element])
};

const mapStateToProps = (state, ownProps) => {
  return {
    isFeatureEnabled:
      ownProps.flag === HAS_ADMIN_ACCESS
        ? isAdminUser(state)
        : selectFeatureFlag(ownProps.flag)(state)
  };
};

export default connect(mapStateToProps)(ToggleFeature);
